import React, { useState, useEffect } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import styles from "./render-checkbox.module.css";
import {
	checkedCheckboxIcon,
	uncheckedCheckboxIcon,
} from "./checkbox-icons";

export default function RenderCheckBox(props) {
	const { members, item, setUserValue, setCheckedSelected } = props;
	const [checked, setChecked] = useState(false);

	useEffect(() => {
		const found = members.find((m) => m === item.user_id);
		setChecked(!!found);
	}, [members, item]);

	const handleChange = (e) => {
		setChecked(e.target.checked);

		if (e.target.checked) {
			setUserValue([...members, item.user_id]);
			setCheckedSelected([item.user_id]);
		} else {
			setUserValue((prev) => prev.filter((itm) => itm !== item.user_id));
			setCheckedSelected([item.user_id]);
		}
	};

	return (
		<Checkbox
			color="default"
			className={styles.root}
			checked={checked}
			icon={uncheckedCheckboxIcon}
			checkedIcon={checkedCheckboxIcon}
			style={{
				transform: "scale(0.85)",
			}}
			onChange={handleChange}
		/>
	);
}
